// extracted by mini-css-extract-plugin
export default {"KbdShortcut":"KbdShortcut3gsETbU1kkU0","KbdShortcut_ghost":"KbdShortcut_ghost2cCTGlKTZP9y","KbdShortcut_outline":"KbdShortcut_outline3YZH02a655f4"};